<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.index')">Events
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.show', [eventInfo.id])">
                {{ eventInfo.name }}
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            <inertia-link class="text-indigo-400 hover:text-indigo-600"
                          :href="route('events.messages.index', [eventInfo.id])">
                Messages
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            Create
        </h1>

        <message-form
            :event-info="eventInfo"
            :from_name="$page.props.auth.user.name"
            :reply_to="$page.props.auth.user.email"
            :field-groups="fieldGroups"
        >
        </message-form>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import MessageForm from './Partials/MessageForm.vue'

export default {
    metaInfo() {
        return {title: 'Create Message'}
    },
    components: {
        MessageForm
    },
    layout: Layout,
    props: {
        eventInfo: Object,
        fieldGroups: Array,
    },
}
</script>
